import React from "react";
import ThreeDotsIcon from "../../icons/three-dots.icon";
import MyDropdown from "../../Common/my-dropdown/my-dropdown-new.component";
import styles from "./integrations-table.module.scss";

export enum IntegrationAction {
  RUN_NOW = "run-now",
  UPDATE_API_KEYS = "update-api-keys",
  SUSPEND = "suspend",
  DELETE = "delete",
}

export const INTEGRATION_ACTION_ITEMS: {
  label: string;
  value: IntegrationAction;
  className?: string;
}[][] = [
  [
    {
      label: "Run Now",
      value: IntegrationAction.RUN_NOW,
    },
  ],
  [
    {
      label: "Update API Keys",
      value: IntegrationAction.UPDATE_API_KEYS,
    },
    {
      label: "Suspend",
      value: IntegrationAction.SUSPEND,
    },
  ],
  [
    {
      label: "Delete",
      value: IntegrationAction.DELETE,
      className: "f-red",
    },
  ]
];

export interface IntegrationActionsCellProps {
  integrationId: string;
}

const handleIntegrationAction = (action: IntegrationAction, integrationId: string): void => {
  console.log("Integration action clicked", { action, integrationId });
};

export const IntegrationActionsCell = ({
  integrationId,
}: IntegrationActionsCellProps) => {
  return (
    <div className={styles.actionsCell}>
      <div className={styles.actionsCellInner}>
        <MyDropdown className={styles.actionsDropdown}>
          <MyDropdown.Toggle className={styles.actionsButton} hideArrow>
            <div className={styles.actionsIconWrapper}>
              <ThreeDotsIcon className={styles.actionsIcon} />
            </div>
          </MyDropdown.Toggle>

          <MyDropdown.Menu alignRight popperConfig={{ strategy: "fixed" }} renderOnMount>
            {INTEGRATION_ACTION_ITEMS.map((group, groupIndex) => (
              <React.Fragment key={groupIndex}>
                {group.map((item) => (
                  <MyDropdown.Item
                    key={item.value}
                    className={item.className}
                    onClick={() => handleIntegrationAction(item.value, integrationId)}
                  >
                    {item.label}
                  </MyDropdown.Item>
                ))}

                {groupIndex < INTEGRATION_ACTION_ITEMS.length - 1 && (
                  <div className="divider" />
                )}
              </React.Fragment>
            ))}
          </MyDropdown.Menu>
        </MyDropdown>
      </div>
    </div>
  );
};


